/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "adminCCPServices/UserService";

export const getUserByEmail = async (email) => {
	try {
		let response = await axios.get(`${APIGateways.userAPIEndpoint}/${email}`, {
			headers: await getAuthHeader(),
		});
		return response.data;
	} catch (error) {
		v2.error(`Error getting user by email`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_USER_BY_ID_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
